import styled from 'styled-components';

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 320px;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 1px solid #e1e1e1;
  gap: 0.5rem;
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;
